import { render, staticRenderFns } from "./VirologyStatus.vue?vue&type=template&id=fc004ba8"
import script from "./VirologyStatus.vue?vue&type=script&lang=js"
export * from "./VirologyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports